import { render, staticRenderFns } from "./_pictures.vue?vue&type=template&id=6a8af9a5"
import script from "./_pictures.vue?vue&type=script&lang=js"
export * from "./_pictures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports